import React, { Component } from 'react';
import { Link } from 'react-router';
import Anchor from "../../../../../../dashboardNew/objects/Anchor";

class CourseOverview extends Component {

    render() {
        const { course } = this.props;
        const currentCourse = Array.isArray(course) ? course[0] : course;

        return (
            <React.Fragment>
                <div className="col-12 course-info">
                    <div className="info-inner">
                        {currentCourse.name && <h2 className="heading-two">{currentCourse.name}</h2>}
                        {currentCourse.description && <p className="body-copy">{currentCourse.description}</p>}
                    </div>
                </div>
            </React.Fragment>
        );

    }

}

export default CourseOverview;


// WEBPACK FOOTER //
// src/client/components/site/features/training/courses/pages/elements/CourseOverview.js